export default "__VITE_ASSET__d82fcb37__"